import { Component, Inject, OnInit } from '@angular/core';
import { LAYOUT_CONFIGURATION_TOKEN, LayoutConfiguration } from '../../tokens';
import { AuthFacade, User } from '@ecosure-suite/back-office/auth/data-access-auth';
import { Parent, Title } from '../../entities';
import { TranslateService } from '@ngx-translate/core';
import { StateService } from '@ecosure-suite/common/util-state-management';
import { INavData } from '@coreui/angular';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit {
  today: number = Date.now();
  //navItems: (Parent | Title)[];
  languages: { code: string; name: string }[];
  sidebarMinimized = true;
  element: HTMLElement = document.body;
  navbarBrandFull: { src: string; width: number; height: number; alt: string };
  navbarBrandMinimized: {
    src: string;
    width: number;
    height: number;
    alt: string;
  };

  private changes: MutationObserver = new MutationObserver(() => {
    this.sidebarMinimized = document.body.classList.contains(
      'sidebar-minimized'
    );
  });

  currentState: string = this.stateService.state;

  private _navItems: INavData[];

  get navItems(): INavData[] {
    return this._navItems;
  }

  constructor(
    @Inject(LAYOUT_CONFIGURATION_TOKEN)
    private configuration: LayoutConfiguration,
    private authService: AuthFacade,
    private translate: TranslateService,
    private stateService: StateService
  ) {
    //this.navItems = configuration.navigation;
    this.languages = configuration.languages;
    this.changes.observe(<Element>this.element, {
      attributes: true
    });

    this.authService.user$.subscribe((user: User) => {
      if (!user) {
        this._navItems = [];
      } else {
        this.setNavItems(user.roles)
      }
    });
  }




  ngOnInit(): void {
    this.navbarBrandFull = {
      src: `assets/brand/${this.currentState}/logo.svg`,
      width: 89,
      height: 25,
      alt: 'EcoSure Logo'
    };

    this.navbarBrandMinimized = {
      src: `assets/brand/${this.currentState}/logo.svg`,
      width: 30,
      height: 30,
      alt: 'EcoSure Logo'
    };
  }

  /**
   * TODO: refactor to loop through an array from userRoles and _nav.ts
   */
  private checkIfNavigationIsAllowed(navData: INavData, userRoles: string[]): INavData {
    /**
     * ? removed this implementation because it wasnt called anywhere
     *  if (!!navData && navData.children && navData.children.length > 0) {
      navData.children.forEach((n, i) => {
        navData[i] = this.checkIfNavigationIsAllowed(n, userRoles);
      });
    }
     */
    if (
      navData.attributes &&
      navData.attributes.roles &&
      navData.attributes.roles.length > 0
    ) {

      const userRole = navData.attributes.roles;

      if (!userRoles.includes(userRole)) {
        navData.class = `d-none`;
      } else {
        return navData;
      }

    }
    return navData;
  }

  logout() {
    this.authService.logout();
  }

  private setNavItems(userRoles: string[]) {
    const navItems = this.configuration.navigation;
    navItems.forEach((navData, index) => {
      navItems[index] = this.checkIfNavigationIsAllowed(navData, userRoles);
    });
    this._navItems = navItems;
  }

  changeLanguage(language) {
    this.translate.use(language);
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
}
